<router-outlet></router-outlet>


// WEBPACK FOOTER //
// ./src/root.component.ts.RootComponent.html